import { render, staticRenderFns } from "./closingOpeningDocument.vue?vue&type=template&id=5b58e180&scoped=true&"
import script from "./closingOpeningDocument.vue?vue&type=script&lang=js&"
export * from "./closingOpeningDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b58e180",
  null
  
)

export default component.exports